import { render, staticRenderFns } from "./PlanSelectionTab.vue?vue&type=template&id=1a5c95be&scoped=true"
import script from "./PlanSelectionTab.vue?vue&type=script&lang=js"
export * from "./PlanSelectionTab.vue?vue&type=script&lang=js"
import style0 from "./PlanSelectionTab.vue?vue&type=style&index=0&id=1a5c95be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5c95be",
  null
  
)

export default component.exports